module.exports = __webpack_public_path__ + "static/media/16.272bb299.jpg";